import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import minifyTheme from 'minify-css-string';
import DataTableFooterIcon from '@/components/Misc/DataTableFooterIcon.vue';
import ApioIcon from '@/components/Misc/Icon.vue';

Vue.use(Vuetify);

export default new Vuetify({
  default: {
    props: {
      depressed: true,
      ripples: false,
    }
  },
  icons: {
    values: {
      first: {
        component: DataTableFooterIcon, 
        props: { 
          name: 'nav-arrow-left-double',
        },
      },
      prev: {
        component: DataTableFooterIcon, 
        props: { 
          name: 'nav-arrow-left-single',
        },
      },
      next: {
        component: DataTableFooterIcon, 
        props: { 
          name: 'nav-arrow-right-single',
        },
      },
      last : {
        component: DataTableFooterIcon, 
        props: { 
          name: 'nav-arrow-right-double',
        },
      },
      cloudalert: {
        component: ApioIcon, 
        props: {
          name: 'ui-cloud-alert',
          lightModeColour: 'black',
          darkModeColour: 'black',
        }
      }
    },
  },
  theme: {
    options: {
      minifyTheme,
      customProperties: true,
    },
    themes: {
      dark: {
        white: '#fff',
        primary: '#2a324f',
        purple: '#6200EA',
        blueblack: '#131720',
        magenta: '#e30e5c',
        blue: '#1e88e5',
        cyan: '#29B6F6',
        apioshade1: '#1d253b',
        apioshade4: '#d2d4e5',
        apioshade2: '#2a324f',
        apioshade3: '#9197b9',
        apioshade5: '#f0f1f7',
        background: '#1d253b',
        success: '#61bb46',
        error: '#e03a3e',
        warning: '#fdb827'
      },
      light: {
        white: '#fff',
        primary: '#2a324f',
        purple: '#6200EA',
        blueblack: '#131720',
        magenta: '#e30e5c',
        blue: '#1e88e5',
        cyan: '#29B6F6',
        apioshade1: '#1d253b',
        apioshade4: '#d2d4e5',
        apioshade2: '#2a324f',
        apioshade3: '#9197b9',
        apioshade5: '#f0f1f7',
        background: '#f0f1f7',
        success: '#61bb46',
        error: '#e03a3e',
        warning: '#fdb827'
      },
    },
  },
});
